import React from 'react'
import SavingImg1 from '../../Images/SavingImg/AkshayakoshSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const AkshayaSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>अक्षयकोष बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>दुवै पक्ष बीच सम्झौता गरी बचत राख्न सकिने ।</li>
                                        <li>अक्षयकोष बचत जीवनपर्यन्त रहने हुनाले सो रकम परिचालनको कार्यविधि पेश गर्नु पर्ने </li>
                                        <li>ब्याजलाई त्रैमासिक रूपमा भुक्तानी गर्न सकिने ।</li>
                                        <li>ब्याजलाई पूँजीकरण गर्न पनि सकिने ।</li>
                                        <li>संस्था मार्फत पनि तोकिएको कार्यमा सहयोग गर्न सकिने ।</li>
                                        <li>न्युनतम मौज्दात रु १,०००।– राखि खाता खोल्न सकिनेछ ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default AkshayaSaving